module.exports = __webpack_public_path__ + "img/login_img_download.91f00c58.png";